module.exports = __webpack_public_path__ + "media/images/bell-1a4098e478a120f7242f167ac11c2dc1.svg";